import React from 'react'
import AddItem from 'icons/additem'
import FilterIcon from 'icons/filter'
import Paint from 'icons/paint'
import Redemption from 'icons/redemption'
import BriefCaseIcon from 'icons/brief-case'
import GroupIcon from 'icons/group'
import BuildingOrganizationIcon from 'icons/building-organization'
import KPIIcon from 'icons/kpi'
import SettingsIcon from 'icons/settings'
import Searchicon from 'icons/searchicon'

// Single source of truth for the Order management sub-modules. `ready` marks the
// modules that have been ported into web; the rest render a "coming soon"
// placeholder until they are migrated from the standalone restaurant admin.
const restaurantModules = [
  { path: 'products', label: 'Products', icon: <AddItem />, ready: true },
  { path: 'categories', label: 'Categories', icon: <FilterIcon />, ready: true },
  { path: 'banners', label: 'Banners', icon: <Paint />, ready: true },
  { path: 'deals', label: 'Deals & Coupons', icon: <Redemption />, ready: true },
  { path: 'orders', label: 'Orders', icon: <BriefCaseIcon />, ready: true },
  { path: 'customers', label: 'Customers', icon: <GroupIcon />, ready: true },
  { path: 'branches', label: 'Store Locations', icon: <BuildingOrganizationIcon />, ready: true },
  { path: 'analytics', label: 'Analytics', icon: <KPIIcon />, ready: true },
  { path: 'settings', label: 'Settings', icon: <SettingsIcon />, ready: true },
  { path: 'seo', label: 'SEO', icon: <Searchicon />, ready: true },
]

export default restaurantModules
